<template>
    <div class="m-head">
        <div class="m-head__text">
            <div class="ta-center">
                <data-text :skin="1" :showNext="true"></data-text>
            </div>
        </div>
        <div class="m-head__comment">
            <comment-list :objType="10" :objId="1" :pageNum="3" :uptime="uptime"></comment-list>
        </div>
        <a href="javascript:;" class="icon-talk" @click="openPost"><span class="kingfont kf-xiaoxi"></span><div>说两句</div></a>
        <router-link :to="{name:'regulation'}" class="guize-link">竞猜规则</router-link>
        <comment-post ref="homeCommentPost" :objType="10" :objId="1" @success="postOk"></comment-post>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import CommentList from '../comment/comment-list'
    import CommenPost from '../comment/comment-post'
    import UpdownDateText from '../../components/updown-date-text'
    import { WZ } from '../../../common/globals'
    export default {
        data() {
            return {
                uptime : 0
            }
        },
        computed: {
            ...mapGetters('home', ['nowTime', 'tomorrow', 'todayIsTransdate', 'nowTimeSection']),
            ...mapGetters('account', ['uid','isRealName']),
        },
        components:{
            'data-text' : UpdownDateText,
            'comment-list' : CommentList,
            'comment-post' : CommenPost,
        },
        methods: {
            openPost(){
                if(!this.uid){
                    WZ.go('login')
                    return
                }
                /* if(!this.isRealName){
                    this.$dialog.confirm({
                        title: '实名认证',
                        message: '大侠！混迹江湖是需要有身份嘀！你还没有实名认证，赶快去补办吧！'
                    }).then(() => {
                        // on confirm
                        WZ.go('realname')
                    }).catch(() => {
                    // on cancel
                    })                   
                    return
                } */
                this.$refs.homeCommentPost.show().then(value=>{
					console.log(value.cid)
				}).catch(() => {
                    console.log('弹层关闭，不需要任何处理')
                })
            },
            postOk(){
                this.uptime = new Date().getTime()
            },
        },
    }
</script>